<!--
=========================================================
* Vue Argon Dashboard 2 PRO - v3.0.1
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-pro
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->

<template>
  <div
    v-show="layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"
  ></div>
    <!-- <p v-if="showInstructions" class="notification-instructions">
      To receive notifications, please enable them in your browser settings.
      <button @click="openNotificationSettings">Open Notification Settings</button>
    </p> -->
  <!-- <sidenav v-if="showSidenav" /> -->
  <main class="main-content position-relative max-height-vh-100 h-100">
    <!-- <navbar-admin v-if="showNavbarAdmin" :showTopSearch="showTopSearch" />
    <navbar-front v-if="showNavbarFront" :showTopSearch="showTopSearch" /> -->
    <!-- <Suspense> -->
      <!-- <div>Support Lib: {{ support_lib_id }}</div> -->
      <router-view />
    <!-- </Suspense> -->
    <!-- <app-footer v-show="showFooter" /> -->
    <!-- <configurator
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
    /> -->
  </main>
</template>
<script>
/* import Sidenav from "./examples/Sidenav"; */
/* import Configurator from "@/examples/Configurator.vue"; */
/* import NavbarAdmin from "@/components/custom/admin/NavbarAdmin.vue";
import NavbarFront from "@/components/custom/front/NavbarFront.vue"; */
import AppFooter from "@/components/custom/Footer.vue";
import { mapState } from "vuex";
/* import { ref } from 'vue'
import getUserInfo from "@/composables/getUserInfo"
import getSupportLibrary from "@/composables/getSupportLibrary" */


export default {
  name: "App",
  components: {
    /* Sidenav, */
    /* Configurator, */
    /* NavbarAdmin,
    NavbarFront, */
    AppFooter
  },
  setup(){
    /* const support_lib_id = ref('');
    console.log("Setting Up");
    const { user_info_error, user_info, load_user_info } = getUserInfo(user.value.uid)
    console.log("Setting Up 2");
    await load_user_info();
    console.log("Setting Up 3");

    if(user_info.value.support_lib_id){
      support_lib_id.value = user_info.value.support_lib_id;
    }
    console.log("Setting Up 4");
    console.log("In App.vue support lib ID: " + support_lib_id.value);
    const { support_lib_error, user_support_library_details, load_support_library  } = getSupportLibrary('n6YtGUlxahUwbpvzImG7')    
    await load_support_library();
    console.log("Support Lib Name: " + user_support_library_details.value.library_domain);
    return { user, user_info_error, user_info, support_lib_error, user_support_library_details, support_lib_id } */
  },
mounted() {
  // When screenshare tab ends, focus this inbox tab (BroadcastChannel / storage fallback)
  try {
    this._screenshareBc = new BroadcastChannel('modal_screenshare');
    this._screenshareBc.onmessage = (event) => {
      if (event?.data?.type === 'screenshare_session_ended') {
        console.log('[upscope-debug][agent-inbox] App: screenshare_session_ended via BroadcastChannel — focusing inbox');
        try {
          window.focus();
        } catch (e) {
          // ignore
        }
      }
    };
  } catch (e) {
    // BroadcastChannel unsupported
  }
  this._onScreenshareStorage = (event) => {
    if (event.key === 'screenshare_session_ended_at' && event.newValue) {
      console.log('[upscope-debug][agent-inbox] App: screenshare_session_ended_at via storage — focusing inbox', {
        newValue: event.newValue,
      });
      try {
        window.focus();
      } catch (e) {
        // ignore
      }
    }
  };
  window.addEventListener('storage', this._onScreenshareStorage);

  const env = ['staging', 'localhost'];
    const location = window.location;
    if (!env.some(envName => window.location.hostname.includes(envName)) || location?.pathname?.toLowerCase()?.startsWith('/advancedwidget')) return;
    const scriptId = 'modal-flowbuilder-script';
    if (document.getElementById(scriptId)) return;

    const script = document.createElement('script');
    script.id = scriptId;
    let localtextContent = `!function(){if(window.modalflow)return;var q=[],mf=window.modalflow={_q:q,_loaded:!1,_cdn:"https://localhost:9599"};["init","identify","startFlow","endFlow","on","off","reset"].forEach(function(m){mf[m]=function(){q.push([m,[].slice.call(arguments)]);return mf}});var s=document.createElement("script");s.async=1;s.src=mf._cdn+"/mf-flowbuilder.js?v="+Date.now();(document.head||document.documentElement).appendChild(s)}();
      modalflow.init('mf_zryggld3g9mpmachkoifs3ptrv', {
        libraryId: 'n6YtGUlxahUwbpvzImG7'
      });
      modalflow.identify('oxeMAWam7yNebUMKseisi0ym8wz1', {
        name: 'Mohit Arya Theleadconnector',
        email: 'mohit.arya+theleadconnector@baam.com'
    });`;

    let s3textContent = `!function(){if(window.modalflow)return;var q=[],mf=window.modalflow={_q:q,_loaded:!1,_cdn:"https://hlptflowbuilder.s3.us-east-1.amazonaws.com/test"};["init","identify","startFlow","endFlow","on","off","reset"].forEach(function(m){mf[m]=function(){q.push([m,[].slice.call(arguments)]);return mf}});var s=document.createElement("script");s.async=1;s.src=mf._cdn+"/mf-flowbuilder.js?v="+Date.now();(document.head||document.documentElement).appendChild(s)}();
      modalflow.init('mf_wolohxa1teb91ad5hrbriaddui', { libraryId: 'n6YtGUlxahUwbpvzImG7' });
      modalflow.identify('oxeMAWam7yNebUMKseisi0ym8wz1', { name: 'Mohit Arya Theleadconnector', email: 'mohit.arya+theleadconnector@baam.com' });`;

    let livetextContent = `!function(){if(window.modalflow)return;var q=[],mf=window.modalflow={_q:q,_loaded:!1,_cdn:"https://cdn2.locationapi.co/mfb"};["init","identify","startFlow","endFlow","on","off","reset"].forEach(function(m){mf[m]=function(){q.push([m,[].slice.call(arguments)]);return mf}});var s=document.createElement("script");s.async=1;s.src=mf._cdn+"/mf-flowbuilder.js?v="+Date.now();(document.head||document.documentElement).appendChild(s)}();
      modalflow.init('mf_zryggld3g9mpmachkoifs3ptrv', { libraryId: 'n6YtGUlxahUwbpvzImG7'  });
      modalflow.identify('oxeMAWam7yNebUMKseisi0ym8wz1', { name: 'Mohit Arya Theleadconnector', email: 'mohit.arya+theleadconnector@baam.com' });`;
      
    if(location.hostname.includes('localhost')){
      script.textContent = localtextContent;
    } else if(location.hostname.includes('staging')){
      script.textContent = s3textContent;
    } else {
      script.textContent = livetextContent;
    }
    document.body.appendChild(script);
  },
  beforeUnmount() {
    try {
      if (this._screenshareBc) {
        this._screenshareBc.close();
      }
    } catch (e) {
      // ignore
    }
    if (this._onScreenshareStorage) {
      window.removeEventListener('storage', this._onScreenshareStorage);
    }
  },
computed: {
    ...mapState([
      "layout",
      "showSidenav",
      /* "showNavbarAdmin",
      "showNavbarFront", */
      "showFooter",
      "showTopSearch",
      "showConfig",
      "hideConfigButton"
    ])
  }
};
</script>
<style>
 .p-skeleton {
    background-color: #edeeea  !important;
  }
</style>